import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../components/navbar/navbar.component';
import { FooterComponent } from '../components/footer/footer.component';
import { Toast } from 'primeng/toast';
import { filter } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, FooterComponent, Toast],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class MainLayoutComponent {
  private readonly router = inject(Router);
  private readonly noFooterRoutes = ['/'];

  private readonly navEnd = toSignal(
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
  );

  readonly showFooter = computed(() => {
    const url = this.navEnd()?.urlAfterRedirects ?? this.router.url;
    return !this.noFooterRoutes.some(r => url === r || url === r.slice(0, -1));
  });
}